<template>
  <GenericSelector
    :options='cargo_container_type'
    :model='model'
    label='Container type'
  />
</template>

<script>
import GenericSelector from './GenericSelector';

export default {
  name: 'ContainerTypeSelector',
  components: {
    GenericSelector,
  },
  data: () => ({
    cargo_container_type: [
      'Dry Cargo Container (G/DV)',
      'Flat Rack Container (P/FL/CF/CN)',
      'High Cube Dry Container (H/DV)',
      'Open Top Container (U/OT)',
      'Platform Container (P/FB)',
      'Reefer Container (R/RE)',
      'Tank Container (T/TC)',
      'Ventilated Container (V/VE)',
    ],
  }),
  props: {
    model: {
      type: String,
      default: 'N/A',
      required: false,
    },
  },
};
</script>

<style scoped>

</style>
